import { useState } from "react";
import axios from "axios";

const LoginForm = () => {
    const [username,setUsername] = useState("");
    const [password,setPassword] = useState("");
    const [error,setError] = useState("");

    const handleSubmit = async(e) => {
           e.preventDefault();
           
           
           const authObject = {"Project-ID" : "fffb4d64-c2e4-4670-83ae-c2335ac73416","User-Name" : username,"User-Secret" : password}
           try {         //using async code
              //username/passowrd => chatengine -> give messages
              await axios.get("https://api.chatengine.io/chats",{headers : authObject});
              //worksout -> logged in
              localStorage.setItem("username",username);
              localStorage.setItem("password",password);

              window.location.reload();
              
           } catch (error) {
               setError("Oops, Incorrect credentials...")
           }
    }

    return (
    <div className="wrapper">
      <div className="form">
          <h1 className="title">Chat Application</h1>
          <form onSubmit={handleSubmit}>
              <input type="text" value={username} onChange={(e) =>setUsername(e.target.value)} className="input" placeholder="Username" required />
              <input type="password" value={password} onChange={(e) =>setPassword(e.target.value)} className="input" placeholder="Password" required />
         <div align="center">
           <button typr="submit" className="button">
               <span>Start Chatting</span>
           </button>
           <h2 className="error">{error}</h2>
         </div>
          </form>
      </div>

    </div>
    );
}
export default LoginForm;